'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStaticDomain = getStaticDomain;
exports.staticURL = staticURL;
exports.isZillowEnv = isZillowEnv;
exports.zillowURL = zillowURL;
function getStaticDomain() {
    var staticDomainNode = typeof document !== 'undefined' && document.querySelector('#zillow-static-domain');
    if (typeof window !== 'undefined' && window.ProxiedReactAppConfig && window.ProxiedReactAppConfig.staticDomain) {
        // Preferred way of loading staticDomain, added by ProxedReactAppContent
        return window.ProxiedReactAppConfig.staticDomain;
    } else if (staticDomainNode && staticDomainNode.value) {
        // For JSONP-loaded pages (hdp on search page) that do not execute the JS to load the above method
        // Added by ProxedReactAppContent with outputAsHidden=true
        return staticDomainNode.value;
    } else if (typeof window !== 'undefined' && window._zconfig && window._zconfig.staticHost) {
        // For external site distribution (used by mortgage pages)
        return '//' + window._zconfig.staticHost + '/';
    }

    return '//www.zillowstatic.com/';
}

/**
 * Helper for resolving paths to static-mortgage assets.
 *
 * @method staticURL
 * @param {String} path The static-path to resolve.
 * @param {String} [bundle] The statics bundle that owns the asset.
 */
function staticURL(givenPath, bundle) {
    var path = givenPath || '';
    if (path.indexOf('/') === 0) {
        path = path.substring(1);
    }

    // Development server path
    if (process.env.NODE_ENV !== 'production') {
        if (typeof window !== 'undefined' && window.location.port === '3000') {
            return '/' + path;
        }
    }

    var bundlePath = '';
    if (bundle) {
        bundlePath = bundle + '/LIVE/';
    }

    // Default to LIVE static path
    return getStaticDomain() + bundlePath + path;
}

/**
 * Checks if the current environment is not a web environment.
 * A non web environment can be a node environment where window.location does not exist (e.g. when running unit tests),
 * or a known development port (e.g. braavos dev server port :3000).
 */
function isNonWebEnv() {
    return typeof window === 'undefined' || typeof window.location === 'undefined' || window.location.port === '3000';
}

/**
 * Checks if the current environment is a zillow environment.
 * This should be true for any of the following:
 *   - Local pre development
 *   - zillow test environments
 *   - tid
 *   - production
 *   - microenvironments
 */
function isZillowEnv() {
    return !isNonWebEnv() && (!!window.location.port || /\.(zillow|securecontactpage|zillowhomeloans|mortgagelendersofamerica)\.(com|net|local)/.test(window.location.hostname));
}

/**
 * Get the zillow origin for for the current environment.
 */
function getZillowOrigin() {
    var zillowOrigin = 'http://www.zillow.com';
    if (isNonWebEnv()) {
        zillowOrigin = 'http://www.develop.zillow.net';
    } else if (isZillowEnv()) {
        // ZM-13233: origin is undefined in Win10 IE11
        // https://connect.microsoft.com/IE/feedback/details/1763802/location-origin-is-undefined-in-ie-11-on-windows-10-but-works-on-windows-7
        zillowOrigin = window.location.origin || window.location.protocol + '//' + window.location.hostname;

        // On mobile apps, domain will be 'localfiles.zillow.com'
        // Generate www.zillow.com links so if apps do not intercept links,
        // pages will not appear broken
        if (zillowOrigin.indexOf('localfiles') >= 0) {
            zillowOrigin = zillowOrigin.replace('localfiles', 'www');
        }
    } // else distribution

    return zillowOrigin;
}

/**
 * Helper for resolving paths to zillow web pages.
 *
 * @method zillowURL
 * @param {String} path The zillow path to resolve.
 * @param {Bool} secure HTTPS links
 */
function zillowURL(givenPath, givenSecure) {
    var secure = givenSecure;
    if (typeof secure === 'undefined') {
        secure = true;
    }
    var path = givenPath || '';
    if (path.indexOf('/') === 0) {
        path = path.substring(1);
    }

    // Start from a standardized insecure origin
    var origin = getZillowOrigin().replace('https:', 'http:').replace(':8443', ':8080');

    var fullpath = origin + '/' + path;
    if (secure) {
        // Always replace 8080 with 8443 if present to make 'secure'
        fullpath = fullpath.replace(':8080', ':8443');
        // Use https protocol if on default port, on dev server, or already using https
        if (!(typeof window !== 'undefined' && typeof window.location !== 'undefined' && window.location.port && window.location.port !== '3000' && window.location.origin && window.location.origin.indexOf('https:') !== 0)) {
            fullpath = fullpath.replace('http:', 'https:');
        }
    }
    return fullpath;
}


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/url/lib/url.js
// module id = 629
// module chunks = 1